export default __webpack_public_path__ + "static/media/me3-modified.df0b8b6d.jpeg";